var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 300,
    viewBox: "-26.67 -43.33 600 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 300 150)",
    id: "a35bd399-7519-4edf-9eb9-d6cf56051926"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -300,
    y: -150,
    rx: 0,
    ry: 0,
    width: 600,
    height: 300
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "ead820ae-c1c6-4292-a196-04d74dd3bef9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13 0 0 1.13 275.44 106.91)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -215.41 42.79)",
    id: "path1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 5.94205,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,59,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-49.86, -167.99)",
    d: "M 63.665336 112.41338 L 22.399121 112.41338 C 19.575232 112.41338 17.173717 114.4029 16.733238 117.10632000000001 L 0.0433216 219.72499 C -0.2885464 221.74964 1.3285536 223.57531 3.4464706 223.57531 L 23.147331 223.57531 C 25.971222 223.57531 28.372737 221.58579 28.813215 218.87651 L 33.314545 191.19868 C 33.748988000000004 188.48941 36.156537 186.49988 38.974393000000006 186.49988 L 52.037902 186.49988 C 79.220866 186.49988 94.90914599999999 173.74349999999998 99.006206 148.46479 C 100.85260000000001 137.40536 99.08470600000001 128.7158 93.74458600000001 122.63018 C 87.87958600000002 115.94771999999999 77.477056 112.41337999999999 63.66533600000001 112.41337999999999 z M 68.42611600000001 149.89257 C 66.16941600000001 164.25229000000002 54.855759000000006 164.25229000000002 43.91619800000001 164.25229000000002 L 37.68916200000001 164.25229000000002 L 42.05774800000001 137.43462000000002 C 42.31719800000001 135.81374000000002 43.765355000000014 134.62003 45.45485900000001 134.62003 L 48.30891500000001 134.62003 C 55.76085900000001 134.62003 62.79040600000001 134.62003 66.42283600000002 138.73951000000002 C 68.58904600000002 141.19717000000003 69.25277600000001 144.84853 68.42611600000002 149.89257000000003 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.27 61.29)",
    id: "path2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 5.94205,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,59,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-142, -186.49)",
    d: "M 187.01746 149.4303 L 167.25626 149.4303 C 165.57279 149.4303 164.1186 150.62402 163.85914 152.24490999999998 L 162.98422 157.60491999999996 L 161.60244 155.66219999999996 C 157.32437 149.64094999999995 147.7847 147.62800999999996 138.26311 147.62800999999996 C 116.42622000000001 147.62800999999996 97.77526600000002 163.66712999999996 94.14284600000002 186.16634999999997 C 92.25420600000002 197.38961999999998 94.93931600000002 208.12136999999996 101.50426000000002 215.60549999999998 C 107.52615000000002 222.48691999999997 116.14263000000001 225.35419 126.39433000000002 225.35419 C 143.98934000000003 225.35419 153.74624000000003 214.38252 153.74624000000003 214.38252 L 152.86528000000004 219.70744 C 152.53342000000004 221.74378 154.15051000000005 223.56946 156.25636000000003 223.56946 L 174.05652000000003 223.56946 C 176.88645000000002 223.56946 179.27589000000003 221.57993 179.72241000000002 218.87066 L 190.40251000000004 153.28060999999997 C 190.74041000000003 151.26183999999998 189.12934000000004 149.43029999999996 187.01746000000003 149.43029999999996 z M 159.47245 186.72809999999998 C 157.56572 197.67632999999998 148.60531 205.02587999999997 137.17700000000002 205.02587999999997 C 131.43871000000001 205.02587999999997 126.85290000000002 203.24116999999998 123.90833000000002 199.85897999999997 C 120.98789000000002 196.50018999999998 119.87766000000002 191.71945999999997 120.80688000000002 186.39453999999998 C 122.58689000000003 175.53991999999997 131.69817000000003 167.95045999999996 142.95149000000004 167.95045999999996 C 148.56307000000004 167.95045999999996 153.12474000000003 169.75857999999997 156.12965000000003 173.17003999999997 C 159.14059000000003 176.61661999999998 160.33531000000002 181.42657999999997 159.47245000000004 186.72809999999998 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.32 74.27)",
    id: "path3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 5.94205,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,59,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-247.95, -199.47)",
    d: "M 292.26168 149.4303 L 272.40394000000003 149.4303 C 270.50928000000005 149.4303 268.72927000000004 150.34314999999998 267.65522000000004 151.8704 L 240.26711000000003 190.99388 L 228.65777000000003 153.39764 C 227.92767000000003 151.04533 225.68908000000002 149.4303 223.15481000000003 149.4303 L 203.641 149.4303 C 201.26966 149.4303 199.62238 151.67730999999998 200.37663999999998 153.84238 L 222.24971999999997 216.09116999999998 L 201.68600999999995 244.24298999999996 C 200.06889999999996 246.46071999999995 201.69860999999995 249.50938999999997 204.49178999999995 249.50938999999997 L 224.32539999999995 249.50938999999997 C 226.20798999999994 249.50938999999997 227.96990999999994 248.61994999999996 229.03790999999995 247.12194999999997 L 295.08557999999994 154.66743999999997 C 296.66646999999995 152.45555999999996 295.0432799999999 149.43029999999996 292.26167999999996 149.43029999999996 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 78.93 42.79)",
    id: "path4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 5.94205,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(23,155,215)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-344.2, -167.99)",
    d: "M 358.00765 112.41338 L 316.73541 112.41338 C 313.91755 112.41338 311.51603 114.4029 311.07555 117.10632000000001 L 294.38564 219.72499 C 294.05377000000004 221.74964 295.67087000000004 223.57531 297.77672 223.57531 L 318.95589 223.57531 C 320.92297 223.57531 322.60645 222.18264 322.91417 220.28674 L 327.65082 191.19868000000002 C 328.08526 188.48941000000002 330.49282 186.49988000000002 333.31067 186.49988000000002 L 346.36815 186.49988000000002 C 373.55714 186.49988000000002 389.23939 173.7435 393.34248 148.46479000000002 C 395.19491000000005 137.40536000000003 393.41498 128.71580000000003 388.07483 122.63018000000002 C 382.21588 115.94772000000002 371.81937000000005 112.41338000000002 358.00765 112.41338000000002 z M 362.76844 149.89257 C 360.51778 164.25229000000002 349.20412 164.25229000000002 338.25851 164.25229000000002 L 332.03751 164.25229000000002 L 336.41212 137.43462000000002 C 336.67159000000004 135.81374000000002 338.10767000000004 134.62003 339.80321000000004 134.62003 L 342.65726 134.62003 C 350.10317000000003 134.62003 357.13876 134.62003 360.77119 138.73951000000002 C 362.93739 141.19717000000003 363.59508999999997 144.84853 362.76844 149.89257000000003 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 171.09 61.29)",
    id: "path5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 5.94205,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(23,155,215)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-436.36, -186.49)",
    d: "M 481.35375 149.4303 L 461.60464 149.4303 C 459.90909 149.4303 458.46698000000004 150.62402 458.21355 152.24490999999998 L 457.33863 157.60491999999996 L 455.95081000000005 155.66219999999996 C 451.67274000000003 149.64094999999995 442.13909000000007 147.62800999999996 432.61751000000004 147.62800999999996 C 410.78062000000006 147.62800999999996 392.13569000000007 163.66712999999996 388.50325000000004 186.16634999999997 C 386.62067 197.38961999999998 389.29371000000003 208.12136999999996 395.85864000000004 215.60549999999998 C 401.8926 222.48691999999997 410.49701000000005 225.35419 420.74873 225.35419 C 438.34374 225.35419 448.10063 214.38252 448.10063 214.38252 L 447.21968000000004 219.70744 C 446.88781000000006 221.74378 448.50491000000005 223.56946 450.62284000000005 223.56946 L 468.4169600000001 223.56946 C 471.23482000000007 223.56946 473.6363300000001 221.57993 474.0768100000001 218.87066 L 484.7629500000001 153.28060999999997 C 485.0887700000001 151.26183999999998 483.4716800000001 149.43029999999996 481.3537500000001 149.43029999999996 z M 453.80876 186.72809999999998 C 451.9141 197.67632999999998 442.94161 205.02587999999997 431.5133 205.02587999999997 C 425.78707 205.02587999999997 421.18921 203.24116999999998 418.24464 199.85897999999997 C 415.32418 196.50018999999998 414.22601000000003 191.71945999999997 415.14316 186.39453999999998 C 416.93526 175.53991999999997 426.03447 167.95045999999996 437.28779000000003 167.95045999999996 C 442.89937000000003 167.95045999999996 447.46103000000005 169.75857999999997 450.46596000000005 173.17003999999997 C 453.4889600000001 176.61661999999998 454.68368000000004 181.42657999999997 453.80876000000006 186.72809999999998 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 243.84 42.79)",
    id: "path6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 5.94205,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(23,155,215)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-509.11, -167.99)",
    d: "M 504.65085 115.22798 L 487.71355 219.72499 C 487.38168 221.74964 488.99878 223.57531 491.10463 223.57531 L 508.13244 223.57531 C 510.96236999999996 223.57531 513.36388 221.58579 513.7982999999999 218.87651 L 530.50028 116.2637 C 530.83215 114.23907 529.21505 112.40753 527.1092 112.40753 L 508.04194 112.40753 C 506.35845 112.41353 504.91031000000004 113.60709999999999 504.65085 115.22797999999999 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.3 -63.29)",
    id: "path7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 4.151,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,59,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-270.57, -61.92)",
    d: "M 247.30817 119.63287 L 249.50428 106.0011 L 244.61237 105.89039 L 221.25298 105.89039 L 237.48656 5.301748 C 237.53726 4.99811 237.70071 4.7149529999999995 237.94007 4.513884 C 238.17944 4.312823 238.48595999999998 4.201995 238.80508 4.201995 L 278.19229 4.201995 C 291.26816 4.201995 300.29196 6.861045000000001 305.00332000000003 12.109403 C 307.21202000000005 14.571487000000001 308.61870000000005 17.144369 309.29895000000005 19.975771 C 310.01279000000005 22.94669 310.0253900000001 26.496202000000004 309.32855000000006 30.825372 L 309.27785000000006 31.141338 L 309.27785000000006 33.915293 L 311.4865700000001 35.138129 C 313.3467500000001 36.102446 314.8248300000001 37.206284 315.95857000000007 38.470154 C 317.8481500000001 40.575241 319.0700800000001 43.250705 319.58655000000005 46.422696 C 320.11984000000007 49.684966 319.9434600000001 53.566862 319.07005000000004 57.961691 C 318.06228000000004 63.017176 316.43304000000006 67.42021 314.23273000000006 71.023068 C 312.20878000000005 74.342787 309.6305500000001 77.09622399999999 306.5694500000001 79.23003299999999 C 303.6469000000001 81.25715299999999 300.17426000000006 82.79596299999999 296.24815000000007 83.78079299999999 C 292.4437900000001 84.749203 288.10616000000005 85.23753299999998 283.34861000000006 85.23753299999998 L 280.28330000000005 85.23753299999998 C 278.09139000000005 85.23753299999998 275.9624600000001 86.00898299999999 274.29123000000004 87.39185299999998 C 272.61581000000007 88.80345299999999 271.50726000000003 90.73209299999998 271.16714 92.84127299999999 L 270.93616000000003 94.06822299999999 L 267.05621 118.0941 L 266.87984 118.97634 C 266.83334 119.25538999999999 266.75389 119.39488999999999 266.63631 119.48928 C 266.53127 119.57548 266.38016999999996 119.63288 266.23319 119.63288 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.22 -47.56)",
    id: "path8"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 4.151,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(23,155,215)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-283.49, -77.65)",
    d: "M 313.57778 31.461381 L 313.57778 31.461381 L 313.57778 31.461381 C 313.46025000000003 32.195902 313.32587 32.946844 313.17465000000004 33.718294 C 307.98043000000007 59.779498000000004 290.20998000000003 68.782538 267.51403000000005 68.782538 L 255.95822000000004 68.782538 C 253.18264000000005 68.782538 250.84375000000003 70.75220300000001 250.41125000000005 73.427673 L 250.41125000000005 73.427673 L 250.41125000000005 73.427673 L 244.49477000000005 110.09638 L 242.81935000000004 120.49047999999999 C 242.53798000000003 122.24677999999999 243.92370000000005 123.83072999999999 245.73770000000005 123.83072999999999 L 266.23333 123.83072999999999 C 268.66038000000003 123.83072999999999 270.72212 122.10726999999999 271.10423000000003 119.76827999999999 L 271.30577000000005 118.75062999999999 L 275.16470000000004 94.81912299999999 L 275.41246000000007 93.506013 C 275.7903800000001 91.158823 277.85631000000006 89.43535299999999 280.28337000000005 89.43535299999999 L 283.34869000000003 89.43535299999999 C 303.20606000000004 89.43535299999999 318.75100000000003 81.55667299999999 323.29439 58.757735 C 325.19236 49.233551999999996 324.20979 41.281006999999995 319.1877 35.687967 C 317.66764 34.001433 315.78226 32.602145 313.57776 31.461381 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 16.72 -74.73)",
    id: "path9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 4.151,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(34,45,101)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-281.99, -50.47)",
    d: "M 308.1442 29.343986 C 307.35058000000004 29.118291 306.53176 28.913117 305.69195 28.728463 C 304.84793 28.547907000000002 303.98291 28.387874 303.09272000000004 28.248353 C 299.97702000000004 27.755934 296.56319 27.522039000000003 292.90580000000006 27.522039000000003 L 262.0342800000001 27.522039000000003 C 261.2742500000001 27.522039000000003 260.5520000000001 27.690282000000003 259.9053600000001 27.993938000000004 C 258.4818600000001 28.662804000000005 257.4237100000001 29.980022000000005 257.1675600000001 31.592690000000005 L 250.6002300000001 72.24177 L 250.4112500000001 73.427673 C 250.84376000000012 70.752203 253.1826300000001 68.782538 255.95821000000012 68.782538 L 267.5140300000001 68.782538 C 290.2099700000001 68.782538 307.9804100000001 59.77539 313.1746500000001 33.718293 C 313.3300400000001 32.946842000000004 313.4601800000001 32.195901000000006 313.5777800000001 31.461380000000002 C 312.2634500000001 30.780201 310.83997000000005 30.197508000000003 309.30732000000006 29.700987 C 308.9294100000001 29.577882000000002 308.53889000000004 29.458878000000002 308.1441700000001 29.343983 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.2 -70.15)",
    id: "path10"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 4.151,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(37,59,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-265.47, -55.05)",
    d: "M 257.16756 31.592692 C 257.42370999999997 29.980024 258.48186 28.662806 259.90536 27.998043 C 260.55620999999996 27.694383 261.27425 27.526146 262.03427999999997 27.526146 L 292.90579999999994 27.526146 C 296.56318999999996 27.526146 299.9770199999999 27.760043 303.09271999999993 28.252461 C 303.98290999999995 28.391979 304.8479299999999 28.552014 305.6919499999999 28.732569 C 306.5317599999999 28.917225000000002 307.3505799999999 29.122399 308.1441999999999 29.348091 C 308.5388899999999 29.462984 308.9294099999999 29.58199 309.3115399999999 29.700992 C 310.8441899999999 30.197513999999998 312.2676799999999 30.784309999999998 313.58199999999994 31.461385 C 315.1272399999999 21.830513 313.5693999999999 15.273150999999999 308.2407799999999 9.335412999999999 C 302.36627 2.798569 291.76364 0 278.19647 0 L 238.80924999999996 0 C 236.03787999999997 0 233.67379999999997 1.969666 233.24549999999996 4.649238 L 216.83976 106.27193 C 216.51647000000003 108.28263 218.10367000000002 110.09638 220.17801 110.09638 L 244.49478 110.09638 L 250.60022999999998 72.24177 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpcom);
export default __webpack_public_path__ + "static/media/ppcom.3ff64ec7c96c8505f9be639c3feabee0.svg";
export { ForwardRef as ReactComponent };